import {
  ArbManifest,
  AsyncMessageBundleManager,
  createAsyncMessageBundleManager,
  LocalizationContextBuilder,
} from '@amzn/arb-tools';
import { NodeEnv } from 'src/constants';

/*
 * `arb-tools compile` generates build/translations/arbManifest.js and emits no
 * declaration beside it, so this relative import has no types. An ambient
 * `declare module` cannot help: TypeScript does not consult those for relative
 * specifiers. The canonical fix is for the generator to emit a co-located
 * arbManifest.d.ts; until it does, the error is suppressed at this one import and
 * the shape is immediately re-asserted below using arb-tools' own ArbManifest type,
 * so nothing downstream is left as `any`.
 *
 * @ts-expect-error (not @ts-ignore) is deliberate: it fails the build if the
 * generator ever starts emitting declarations, so this suppression cannot go stale.
 */
// @ts-expect-error -- generated artifact ships no .d.ts; see the note above
import generatedArbManifest from '../../../build/translations/arbManifest';
// @ts-expect-error -- same generated artifact
import { endpointMap as genEndpointMap } from '../../../build/translations/arbManifest';

const arbManifest: ArbManifest = generatedArbManifest;
const endpointMap: ArbManifest['endpointMap'] = genEndpointMap;

const defaultLocale = 'en-US';

export const formatLocale = (locale: string): string => {
  locale = locale?.replace('_', '-');

  if (!Object.prototype.hasOwnProperty.call(endpointMap, locale)) {
    return defaultLocale;
  }

  return locale;
};

let manager: AsyncMessageBundleManager;

export const mbmInitializer = (locale: string) => {
  const localizationContextProvider = () =>
    new LocalizationContextBuilder()
      .withLocale(locale)
      .withDefaultLocale(defaultLocale)
      .build();

  return () => {
    if (!manager) {
      manager = createAsyncMessageBundleManager({
        arbManifest,
        localizationContextProvider,
        urlPrefix: 'translations',
        resolveBundleUrl: (url?: string) => {
          if (url) {
            return process.env.NODE_ENV === NodeEnv.development
              ? `/translations/${url}`
              : `https://d1eydj7jwazt8k.cloudfront.net/translations/${url}`;
          }
          return undefined;
        },
      });
    }
    return manager;
  };
};
